<template>
  <div id="appMain">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'appMain',
  data(){
    return {

    }
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll)
  },
  methods:{
    handleScroll(){
      this.scrollPosition = window.scrollY
    }
  }
}
</script>